<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              <v-icon left color="accent">mdi-clipboard-text</v-icon>Orders
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <shop-select
              v-model="shopId"
              style="align-items:center"
            ></shop-select>
            <v-spacer></v-spacer>
            <v-btn outlined color="accent" @click="form = !form">
              <v-icon left>mdi-plus</v-icon>Create Order
            </v-btn>
            <template v-slot:extension>
              <v-tabs v-model="tabs">
                <v-tab>New</v-tab>
                <v-tab>Open</v-tab>
                <v-tab>Close</v-tab>
                <v-tab>Cancel</v-tab>
                <v-tab>All</v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <order-table status="new" :shopId="shopId" />
            </v-tab-item>
            <v-tab-item>
              <order-table status="open" :shopId="shopId" />
            </v-tab-item>
            <v-tab-item>
              <order-table status="close" :shopId="shopId" />
            </v-tab-item>
            <v-tab-item>
              <order-table status="cancel" :shopId="shopId" />
            </v-tab-item>
            <v-tab-item>
              <order-table />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="form" width="980px">
      <v-card>
        <v-card-title>Create an order</v-card-title>
        <order-form v-on:orderCreate="open($event.order.id)"></order-form>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ShopSelect from "@components/forms/select/Shop.vue";
import OrderTable from "@/components/orders/OrderTable";
import OrderForm from "@components/orders/OrderForm";
import { mapActions } from 'vuex';
import hasQueryParams from '../../mixins/hasQueryParams.vue';

export default {
  name: 'OrdersList',
  mixins: [hasQueryParams],
  components: {
    OrderForm,
    OrderTable,
    ShopSelect,
  },
  data : () => ({
    tabs: 0,
    form: false,
    shopId: null,
    queryFields: ['shopId', 'orderListTab'],
  }),
  mounted: function() {
    this.parseQuery()
  },
  watch: {
    shopId () {
      this.pushNewRoute()
    },
    tabs () {
      this.pushNewRoute()
    }
  },
  computed: {
    openOrder: function() {
      return this.tableData.filter((row) => row.statusId == "open");
    },
    newOrder: function() {
      return this.tableData.filter((row) => row.statusId == "new");
    },
    closeOrder: function() {
      return this.tableData.filter((row) => row.statusId == "close");
    },
    query () {
      return {
        shopId: this.shopId ? this.shopId.toString() : null,
        orderListTab: this.tabs
      }
    }
  },
  methods: {
    ...mapActions("orders", { getOrders:'index' }),
    parseQuery(){
      this.shopId = this.$route.query.shopId ? parseInt(this.$route.query.shopId): null
      this.tabs = this.$route.query.orderListTab ? parseInt(this.$route.query.orderListTab): 0
    },
    open(id) {
      this.$router.push("/orders/view/" + id);
    }
  },
};
</script>

<style></style>
